
(function() {
    const $form = $('#searchForm');
    const $root = $('.search-input-wrapper');
    const $searchInput = $('#search-field');
    const $searchInputClearBtn = $('.search-clear-btn');
    const $searchBtn = $('#search-submit');
    const $results = $('#results');
    const onIndex = $results.length;

    $searchBtn.on('click', (e) => {
        if (!onIndex) {
            e.preventDefault();
        }
        if (!$root.hasClass('expand')) {
            $root.addClass('expand');
            setTimeout(() => {
                $searchInput.focus(); // TODO: fix on iOS?
            }, 420);
        } else if (!onIndex) {
            let q = $searchInput.val();
            if (q) {
                console.log('submit')
                console.log(q)
                window.location = `/?q=${encodeURI(q)}`;
            }
        }
    });

    $(document).on('click', (e) => {
        const within = $(e.target).closest('.site-search input').length
          || $(e.target).closest('.site-search a').length
          || $(e.target).closest('.site-search label').length;
        const queryLength = $searchInput.val().length;
        if (!within && queryLength == 0) {
            $root.removeClass('expand');
        }
    });
    

    function clearSearchField() {
        $searchInput.val('');
        $searchInput.trigger('input');
        $searchInputClearBtn.removeClass('show');
        $searchInput.focus();
        showHideResults();
    }

    $searchInput.on('input', (e) => {
        // Toggle input clear button visibillity.
        let queryLength = $searchInput.val().length;
        console.log(queryLength);
        if (queryLength > 0) {
            $searchInputClearBtn.addClass('show');
        } else {
            $searchInputClearBtn.removeClass('show');
        }
    });

    $searchInputClearBtn.on('click', () => clearSearchField());

    
    if (!onIndex) {
        $form.on('submit', () => {
            console.log('submit')
            let q = $searchInput.val();
            console.log(q)
            window.location = `/?q=${encodeURI(q)}`;
        });
        return;
    }

    
    if (!onIndex) return;
    
    const $categoryPosts = $('#category-posts');
    
    let key = $root.attr('data-k');
    
    // SearchinGhost minimal configuration
    var searchinGhost = new SearchinGhost({
        key,
        inputId: ['search-field'],
        outputId: ['results'],
        // url: window.location.origin,
        // version: 'v3',
        // loadOn: 'focus',
        searchOn: 'submit',
        // limit: 10,
        // inputId: ['search-bar'],
        // outputId: ['search-results'],
        // outputChildsType: 'li',
        // postsFields: ['title', 'url', 'excerpt', 'custom_excerpt', 'published_at', 'feature_image'],
        // postsExtraFields: ['tags'],
        // postsFormats: ['plaintext'],
        // indexedFields: ['title', 'string_tags', 'excerpt', 'plaintext'],
        template: function(post) {

            // patch urls because for some reason they start with the instead of blog.motionvfx.com
            post.url = post.url.replace(/^https?:\/\/[\d\.]+/, 'https://blog.motionvfx.com');

            let o = '<article class="post-card">';
            if (post.feature_image) {
                o += `
                    <a class="post-card-image-link" href="${post.url}">
                        <img class="post-card-image" src="${post.feature_image}">
                    </a>`
            }
            o += `<div class="post-card-content">
                    <a class="post-card-content-link" href="${post.url}">
                            <header class="post-card-header">
                                    <div class="post-card-primary-tag">${post.tags[0].name}</div>
                                <h2 class="h3 post-card-title">${post.title}</h2>
                            </header>
                    </a>
                    <footer class="post-card-meta">
                        <div class="post-card-byline-content">
                            <span class="post-card-byline-date"><time datetime="2021-11-18">Nov 18, 2021</time> <span class="bull">•</span> 1 min read</span>
                        </div>
                    </footer>
                </div>
                `;
            o += '</article>';
            
            // if (post.tags.length > 0) {
            //     o += `<header>
            //             <span class="head-tags">${post.tags[0].name}</span>
            //             <span class="head-date">${post.published_at}</span>
            //           </header>`
            // } else {
            //     o += `<header>
            //             <span class="head-tags">UNKNOWN</span>
            //             <span class="head-date">${post.published_at}</span>
            //           </header>`
            // }
            // o += `<h2>${post.title}</h2>`
            // o += `</section></a>`
            return o;
        },

        // emptyTemplate: function() {},
        customProcessing: function(post) {
            // if (post.tags) post.string_tags = post.tags.map(o => o.name).join(' ').toLowerCase();
            console.log(post.url);
            post.url = post.url.replace(/^[\d\.]+/, 'https://blog.motionvfx.com');
            return post;
        },
        // date: {
        //     locale: document.documentElement.lang || "en-US",
        //     options: { year: 'numeric', month: 'short', day: 'numeric' }
        // },
        // cacheMaxAge: 1800,
        // onFetchStart: function() {},
        // onFetchEnd: function(posts) {},
        // onIndexBuildStart: function() {},
        // onIndexBuildEnd: function(index) {},
        // onSearchStart: function() {},
        onSearchEnd: function(posts) {
            showHideResults(posts.length);
        },
        // indexOptions: {},
        // searchOptions: {},
        // debug: false
    });


    let q = getQuery();
    if (q) {
        $searchInput.val(q).trigger('input');
        $searchBtn.click();
    }
    
    function getQuery() {
        const query = new URLSearchParams(window.location.search);
        const q = query.get('q')
        return q;
    }

    function showHideResults(postCount) {
        let queryLength = $searchInput.val().length;
        let showResults = !!queryLength;
        let hasPosts = !!postCount;

        if (showResults && !postCount) {
            $results.html('<div class="no-results">No results.</div>');
        }
        $results.toggleClass('show', showResults);
        $categoryPosts.toggleClass('show', !showResults || !hasPosts);
    }
})();